export const PLAYER_DEAD = 'd';
export const PLAYER_ALIVE = 'a';
